<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div v-if="$route.params.id"  class="col-sm-12 text-center">
        <h2>Offer {{$route.params.id}}</h2>
      </div>
      <div class="col-lg-8">
        <motor-vehicle-details v-if="motor.data && STEP === 1" :data="data" :lovs="lovs" @next="next" />
        <motor-owner-details v-if="motor.data && STEP === 2" :data="data" :lovs="lovs" @next="next" @previous="previous" />
        <motor-package-selection v-if="motor.data && STEP === 3" :data="data" :lovs="lovs" @next="next" @previous="previous" />
        <motor-optional-cover v-if="motor.data && STEP === 4" :data="data" :lovs="lovs" @next="next" @previous="previous" />
        <motor-plan-selection v-if="motor.data && STEP === 5" :data="data" :lovs="lovs" @submit="submit" @previous="previous" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import messages from '@/shared/modules/notifications';
import MotorVehicleDetails from '../Motor/ComponentsMotor/MotorVehicleDetails.vue';
import MotorOwnerDetails from '../Motor/ComponentsMotor/MotorOwnerDetails.vue';
import MotorPackageSelection from '../Motor/ComponentsMotor/MotorPackageSelection.vue';
import MotorOptionalCover from '../Motor/ComponentsMotor/MotorOptionalCovers.vue';
import MotorPlanSelection from '../Motor/ComponentsMotor/MotorPlanSelection.vue';

export default {

  components: {
    MotorVehicleDetails,
    MotorOwnerDetails,
    MotorPackageSelection,
    MotorOptionalCover,
    MotorPlanSelection
  },
  data() {
    return {
      STEP: 1,
    };
  },
  computed: {
    ...mapState({
      motor: (state) => state.motor.motor
    }),
    data() {
      return JSON.parse(JSON.stringify(this.motor.data));
    },
    lovs() {
      return JSON.parse(JSON.stringify(this.motor.lovs));
    },
  },
  async created() {
    await this.loadMotorData();
  },
  methods: {
    ...mapActions('motor', ['getMotorAdminDataAction', 'updateValue']),
    ...mapActions('offer', ['addOfferAction']),
    async loadMotorData() {
      await this.getMotorAdminDataAction({ offer: this.$route.params.id });
    },
    async submit() {
      await this.addOfferAction(this.data);
      messages({ type: 'success', message: 'New offer Added to cart!' });
      this.$router.push({ name: 'HomePage' });
    },
    next() {
      this.updateValue({ path: 'motor.data', value: this.data });
      this.STEP++;
    },
    previous() {
      this.STEP--;
    }
  }
};
</script>
